export const DEFAULT_PAGINATION_LIMIT = 25;

export const POSSIBLE_LIMITS = [25, 50, 100];
